import React from "react";
import {
    StyleSheet,
    Text,
    View,
    ImageBackground,
    ScrollView,
    TouchableOpacity,
    TextInput,
    Image,
    Alert,
    // ToastAndroid
} from 'react-native';

import {RFValue} from "react-native-responsive-fontsize";
import axios from "axios";
import AsyncStorage from "@react-native-async-storage/async-storage";
// import Toast from "react-native-tiny-toast";
import ToastNotification from 'react-native-toast-notification'
import Config from "../../components/Config";





const Package = ({navigation})=>{


    let [packages,setPackages] = React.useState([]);
    let [toast,setToast] = React.useState(false);

    React.useEffect(()=>{
        getCrypto();
    },[]);


    const getCrypto = async ()=>{
        let res = await axios.get(
            `${Config.base}/api/v1/packageList`
        );
        packages = res.data;
        setPackages(res.data)
    }



    const buypack = async (id)=>{


        setToast('Sending Data ...');


        // Toast.showLoading('Sending Data ...');
        let token = await AsyncStorage.getItem('token');

        let res = await axios.get(
            `${Config.base}/api/v1/buyPack/${id}`,
            { params:
                    {
                        token: token
                    }
            }
        );
        // Toast.hide('');
        setToast(false);
        if(res.data.status == 200){
            navigation.navigate('Profile');

            setToast(res.data.message);

            const timeoutId = setTimeout(() => {
                setToast(false);
            }, 3000);

            // Toast.showSuccess('The new pack has been activated for you');
            // ToastAndroid.show('The new pack has been activated for you', ToastAndroid.SHORT);
        }else{
            // Alert.alert('Error', res.data.message, [
            //     {
            //         text: 'Close',
            //         onPress: () => {
            //         },
            //         style: 'default',
            //     },
            // ]);
            // Toast.show(res.data.message);
            // ToastAndroid.show(res.data.message, ToastAndroid.SHORT);
            setToast(res.data.message);

            const timeoutId = setTimeout(() => {
                setToast(false);
            }, 3000);
        }

    }

    return (
        <View style={{flex : 1}} >
            <ImageBackground req source={{uri: 'https://metamax.network/public/appBg.jpg'}} resizeMode="cover" style={{flex : 1,}}>

                <Text style={styles.header1}>Investment package</Text>
                {toast.length &&
                    <ToastNotification
                        // textStyle={{ color: 'red' }}
                        // style={{ backgroundColor: 'yellow' }}
                        text={toast}
                        // duration={99999999999}
                        isTop={true}
                        style={{ padding: RFValue(10) }}
                    />
                }
                {packages.length > 0 &&
                    <ScrollView style={{paddingBottom : 20}}>

                        {packages.map((item,index)=>
                            <TouchableOpacity key={index} style={styles.box}>
                                <View style={{flexDirection : 'row',justifyContent : 'space-between',alignItems : 'center'}}>

                                    <View style={{justifyContent : 'center',alignItems : 'center'}}>
                                        <Text style={styles.headertext}>
                                            {item.option2}
                                        </Text>

                                        <Image
                                            resizeMode={'stretch'}
                                            fadeDuration={999}
                                            style={{
                                                width : RFValue(100),
                                                height : RFValue(100),
                                                marginVertical : 20,
                                                borderRadius : 10,
                                            }}
                                            source={require('./../../assets/reward.jpg')}/>
                                    </View>


                                    <View style={{flex : 1 , alignItems : 'left',}}>
                                        <Text style={styles.titletext}>
                                            {item.title}
                                        </Text>

                                        <Text style={styles.returntext}>
                                            {item.option3}

                                        </Text>
                                        <Text style={styles.returntext}>

                                            {item.option4}
                                        </Text>


                                        <Text style={styles.titletext}>
                                            {item.option1}
                                        </Text>
                                    </View>
                                </View>
                                <View style={styles.footer}>
                                    <Text style={styles.rewardtext}>
                                        {item.price}
                                    </Text>
                                    <TouchableOpacity onPress={()=>buypack(item.id)} style={{alignItems : 'flex-end' , flex : 1}}>
                                        <View style={styles.btn}>
                                            <Text  style={styles.btntext}>Pay</Text>
                                        </View>
                                    </TouchableOpacity>
                                </View>
                            </TouchableOpacity>
                        )}

                    </ScrollView>
                }




            </ImageBackground>




        </View>
    );
}


const styles = StyleSheet.create({

    progress : {
      width : '85%',
      backgroundColor : '#FFF',
        height : RFValue(10),
        marginVertical : RFValue(15),
        borderRadius : RFValue(25),
        borderWidth : 2,
        borderColor : '#FFF',

    },

    rewardtext: {
        // color : F#f10a0a',
        color : '#FFF',
        fontFamily : 'novaria',
        textAlign : "justify",
        fontSize : RFValue(19),
        paddingHorizontal : RFValue(10),
    },

    titletext : {
        color : '#FFF',
        fontFamily : 'novaria',
        textAlign : "left",
        fontSize : RFValue(12),
        paddingHorizontal : RFValue(10),
        marginVertical : RFValue(10),
    },

    returntext:{
        color : '#FFF',
        fontFamily : 'novaria',
        textAlign : "justify",
        fontSize : RFValue(10),
        paddingHorizontal : RFValue(10),
        paddingVertical : RFValue(0),
    },


    footer : {
      borderTopWidth : 1 ,
      borderTopColor : '#999',
        paddingTop : RFValue(8),
        flexDirection : 'row',
    },

    headertext : {
      flex : 1,
        color : '#FFF',
        fontFamily : 'novaria',
        textAlign : "center",
        fontWeight : 'bold',
        fontSize : RFValue(14)
    },

    box :{
        backgroundColor : 'rgba(255, 255, 255,0.4)',
        marginHorizontal : RFValue(15),
        marginTop : RFValue(8),
        borderRadius : RFValue(10),
        padding : RFValue(15),

    },

    btn : {

        borderWidth : 1,
        borderColor : '#07bdad',
        width : RFValue(90),
        justifyContent : "center",
        alignItems: 'center',
        padding : RFValue(7),
        borderRadius : RFValue(5),
        backgroundColor : '#07bdad',
        marginHorizontal : RFValue(8),
    },


    btntext : {
        color : '#FFF',
        fontFamily : 'novaria',
        fontSize : RFValue(11),

    },
    header1 : {
        fontFamily : 'novaria',
        color : '#FFF',
        textAlign : 'center',
        fontSize : RFValue(16),
        padding : RFValue(17),
        fontWeight  : 'bold',
        textShadowOffset: {width: -1, height: 1},
        textShadowRadius: 4,


    }


});


export default Package;
